<template>
  <Teleport to="body">
    <div
      v-if="isVisible"
      class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
      @click="closeModal"
    >
      <div
        class="bg-white rounded-3xl p-8 max-w-md w-full mx-auto shadow-2xl transform transition-all duration-300"
        @click.stop
      >
        <!-- 关闭按钮 -->
        <button
          class="absolute top-4 right-4 w-8 h-8 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors duration-200"
          @click="closeModal"
        >
          <X class="w-5 h-5 text-gray-600" />
        </button>

        <!-- 标题 -->
        <div class="text-center mb-6">
          <div class="w-16 h-16 sm:w-16 sm:h-16 rounded-full overflow-hidden mx-auto mb-4">
            <img src="/logo.png" alt="猫星球 Logo" class="w-full h-full object-cover" />
          </div>
          <h2 class="text-2xl font-bold text-gray-900 mb-2">下载猫星球APP</h2>
          <p class="text-gray-600">{{ title }}</p>
        </div>

        <!-- 二维码 -->
        <div class="flex justify-center mb-6">
          <div class="bg-gray-50 p-6 rounded-2xl">
            <div class="w-48 h-48 bg-white rounded-xl flex items-center justify-center border-2 border-gray-200">
              <!-- 这里应该是真实的二维码图片 -->
              <div class="text-center">
                <div class="w-32 h-32 bg-gradient-to-br from-primary-100 to-secondary-100 rounded-lg mb-3 flex items-center justify-center">
                  <div class="grid grid-cols-8 gap-0.5">
                    <div v-for="i in 64" :key="i" :class="[
                      'w-1 h-1',
                      Math.random() > 0.5 ? 'bg-gray-900' : 'bg-transparent'
                    ]"></div>
                  </div>
                </div>
                <p class="text-xs text-gray-500">扫描二维码</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 说明文字 -->
        <div class="text-center mb-6">
          <p class="text-gray-700 leading-relaxed">{{ description }}</p>
        </div>

        <!-- 应用商店按钮 -->
        <div class="grid grid-cols-2 gap-4">
          <a
            href="#"
            class="flex items-center justify-center px-4 py-3 bg-black text-white rounded-xl hover:bg-gray-800 transition-colors duration-200"
          >
            <div class="text-left">
              <div class="text-xs opacity-75">Download on the</div>
              <div class="text-sm font-semibold">App Store</div>
            </div>
          </a>
          <a
            href="#"
            class="flex items-center justify-center px-4 py-3 bg-green-600 text-white rounded-xl hover:bg-green-700 transition-colors duration-200"
          >
            <div class="text-left">
              <div class="text-xs opacity-75">Get it on</div>
              <div class="text-sm font-semibold">Google Play</div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { X } from 'lucide-vue-next'

interface Props {
  isVisible: boolean
  title: string
  description: string
}

defineProps<Props>()

const emit = defineEmits<{
  close: []
}>()

const closeModal = () => {
  emit('close')
}
</script>

<style scoped>
/* 弹窗动画 */
.v-enter-active,
.v-leave-active {
  transition: all 0.3s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  transform: scale(0.95);
}
</style>
